import { underscore } from 'inflected';
import { metaKey } from '~/scripts/utils';
import { uniq } from 'lodash';

export default async ({ $api, app, error, redirect, route, store }) => {
  const slug = route.params.provider.toLowerCase();
  const coverType = store.getters['products/getCoverType'];
  const product = underscore(coverType ? coverType.product : metaKey(route, 'product').split('/').pop());
  await $api(`providers/providers/${slug}`, { product }).then(provider => {
    store.commit('providers/set', provider);
    let breadcrumbs = [ ...metaKey(route, 'providerBreadcrumbs') ];
    breadcrumbs.push(provider.name);
    breadcrumbs = uniq(breadcrumbs);
    const metaTagOptions = { ...route.meta[0].metaTagOptions, ...{ params: [provider.name] } };
    route.meta[0] = { ...route.meta[0], ...{ breadcrumbs, metaTagOptions, jumbotronParams: { providerName: provider.name } } };
  });
};
